import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "company-tabs",
  role: "group",
  "aria-label": "Саппортер"
}
const _hoisted_2 = { class: "property-grid" }
const _hoisted_3 = {
  key: 0,
  class: "ui-empty"
}
const _hoisted_4 = {
  key: 1,
  class: "ui-empty"
}

import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';

import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import axios from 'axios';
import { useRouter, useRoute } from 'vue-router';
import { useMainStore } from '../store';
import PropertyCard from './PropertyCard.vue';

const limit = 30;

export default /*@__PURE__*/_defineComponent({
  __name: 'PropertyList',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useMainStore();

const companyTab = ref(0);
const items = ref({
  count: 0,
  next: '',
  previous: '',
  results: [] as any[],
});
const tabCompanies = ref<Company[]>([]);
const busyOrDisabled = ref(false);
const prevUri = ref('');
const loading = ref(false);
const loadMoreTrigger = ref<HTMLElement | null>(null);
let scrollObserver: IntersectionObserver | null = null;

watch(companyTab, async (val) => {
  let query: any;
  if (val != null && val != 0) {
    query = {
      q: store.query,
      supporter: tabCompanies.value[val].id.toString(),
    };
  } else {
    if (store.query != '') {
      query = {
        q: store.query,
      };
    } else {
      query = null;
    }
  }

  await router.push({
    name: 'home',
    query,
  });
  clearItems();
});

// Watch store query changes
watch(
  () => store.getQuery(),
  () => {
    clearItems();
  }
);

function clearItems() {
  items.value.count = 0;
  items.value.next = '';
  items.value.previous = '';
  items.value.results = [];
  loadMore();
}

async function loadMore() {
  const supporterId = route.query.supporter;
  busyOrDisabled.value = true;
  loading.value = true;

  try {
    if (items.value.count != 0 && (items.value.next == '' || items.value.next == null)) {
      busyOrDisabled.value = true;
      return;
    }

    let offsetParam: any = null;
    if (items.value.next != '') {
      const urlNextString = new URL(items.value.next);
      offsetParam = urlNextString.searchParams.get('offset');
    }

    const request = {
      url: '/api/properties',
      params: {
        limit: limit,
        supporters__supporter: supporterId,
        offset: offsetParam,
        search: store.query == '' ? null : store.query,
      },
    };

    const uri = axios.getUri(request);

    if (uri == prevUri.value) {
      return;
    }

    const response = (await axios.get(uri)).data as PagedList<Property>;

    items.value.count = response.count;
    items.value.next = response.next == null ? '' : response.next;
    items.value.previous = response.previous == null ? '' : response.previous;
    if (response.results) {
      for (const prop of response.results) {
        if (prop) {
          items.value.results.push(prop);
        }
      }
    }

    prevUri.value = uri;
    busyOrDisabled.value = false;
  } finally {
    loading.value = false;
  }
}

// Setup intersection observer for infinite scroll
onMounted(async () => {
  await initCompanies();
  if (!loading.value) await loadMore();

  // Simple infinite scroll implementation
  if (loadMoreTrigger.value) {
    scrollObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !busyOrDisabled.value) {
          loadMore();
        }
      },
      { threshold: 0.1 }
    );
    scrollObserver.observe(loadMoreTrigger.value);
  }
});

onBeforeUnmount(() => scrollObserver?.disconnect());

async function initCompanies() {
  const companies = await store.getCompanies();

  const allTabCompany = {
    id: 0,
    name: 'Все',
  } as Company;
  tabCompanies.value.push(allTabCompany);
  companies.forEach((element) => {
    tabCompanies.value.push(element);
  });
  tabCompanies.value = tabCompanies.value.sort((x, y) => (x.id > y.id ? 1 : -1));

  const currentSupporterFilter = route.query['supporter'];
  if (currentSupporterFilter) {
    const filterId = Number(currentSupporterFilter);
    const filterCompany = tabCompanies.value.find((x) => x.id == filterId);
    if (filterCompany) {
      const index = tabCompanies.value.indexOf(filterCompany);
      companyTab.value = index;
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabCompanies.value, (company, index) => {
        return (_openBlock(), _createBlock(_unref(Button), {
          key: company.id,
          variant: companyTab.value === index ? 'default' : 'ghost',
          size: "sm",
          "aria-pressed": companyTab.value === index,
          onClick: ($event: any) => (companyTab.value = index)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(company.name), 1)
          ]),
          _: 2
        }, 1032, ["variant", "aria-pressed", "onClick"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.results, (o) => {
        return (_openBlock(), _createBlock(PropertyCard, {
          key: o.id,
          property: o
        }, null, 8, ["property"]))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "loadMoreTrigger",
      ref: loadMoreTrigger,
      class: "load-more-trigger"
    }, null, 512), [
      [_vShow, !busyOrDisabled.value]
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Spinner)),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "Загрузка клиентов…", -1))
        ]))
      : (!items.value.results.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Клиенты не найдены"))
        : _createCommentVNode("", true)
  ]))
}
}

})